import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Styled community pricing banner - horizontal single-line banner
const CommunityBanner = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})(({ theme, compact }) => ({
  position: 'absolute',
  top: compact ? '4px' : '10px',
  right: compact ? '4px' : '10px',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  borderRadius: '4px',
  height: compact ? '18px' : '24px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: compact ? '0 6px' : '0 8px',
  zIndex: 10,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  gap: '4px',
}));

const CommunityPricingBubble = ({ community, compact = false }) => {
  // Only show if community exists
  if (!community || !community.name) {
    return null;
  }

  // Get first word of community name
  const firstWord = community.name.split(' ')[0];

  return (
    <CommunityBanner compact={compact}>
      <Typography 
        variant="caption" 
        sx={{ 
          fontSize: compact ? '0.6rem' : '0.7rem', 
          lineHeight: 1, 
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.02em',
          whiteSpace: 'nowrap',
        }}
      >
        {firstWord} price
      </Typography>
    </CommunityBanner>
  );
};

export default CommunityPricingBubble;
